import React, {lazy, Suspense} from 'react';
import {UpsellOptionModel} from '../../../../../../domain/models/LineItems/UpsellOption.model';
import {Skeleton as SkeletonContainer} from '../../../../Skeleton/Skeleton';
import {SkeletonSection} from '../../../../Skeleton/SkeletonSection/SkeletonSection';
import {SkeletonRow} from '../../../../Skeleton/SkeletonRow/SkeletonRow';
import {SkeletonLineWrapper} from '../../../../Skeleton/SkeletonLine/SkeletonLineWrapper';
import s from './UpsellOptions.scss';

export enum UpsellOptionsDataHook {
  Root = 'UpsellOptions.root',
  Title = 'UpsellOptions.title',
  Select = 'UpsellOptions.select',
  Skeleton = 'UpsellOptions.skeleton',
  OptionPrice = 'UpsellOptions.optionPrice',
}

export interface UpsellOptionsProps {
  options: UpsellOptionModel[];
  isLoading: boolean;
  disabled: boolean;
  onOpen: () => void;
  onSelect: (option: UpsellOptionModel) => Promise<void> | void;
}

const UpsellOptionsDropdown = lazy(() =>
  import('./UpsellOptionsDropdown').then((module) => ({default: module.UpsellOptionsDropdown}))
);

const UpsellSkeleton = () => (
  <SkeletonContainer dataHook={UpsellOptionsDataHook.Skeleton}>
    <SkeletonSection>
      <SkeletonRow>
        <SkeletonLineWrapper />
      </SkeletonRow>
    </SkeletonSection>
  </SkeletonContainer>
);

export const UpsellOptions = ({options, isLoading, disabled, onOpen, onSelect}: UpsellOptionsProps) => {
  if (isLoading) {
    return <UpsellSkeleton />;
  }

  return (
    <div className={s.root} data-hook={UpsellOptionsDataHook.Root}>
      <Suspense fallback={<UpsellSkeleton />}>
        <UpsellOptionsDropdown options={options} disabled={disabled} onOpen={onOpen} onSelect={onSelect} />
      </Suspense>
    </div>
  );
};
